import useWalletStore from '@/lib/store/useWalletStore'
import LangModule from '../Lang'
import MenuModule from '../Menu'

import { ReactComponent as LOGO } from '@/assets/logo.svg'
import useLayoutScrollHooks from '@/hooks/useLayoutScrollHooks'
import { cnTw } from '@/utils'
import { Link } from 'react-router-dom'

export default function TopBarModule() {
	const isSign = useWalletStore(state => state.isSign)
	const { transparency } = useLayoutScrollHooks()
	return (
		<div
			className={cnTw(
				'fixed flex h-[4.5rem] w-full items-center justify-between px-8 py-4 sm:absolute sm:rounded-t-2xl sm:!bg-black',
				!isSign && 'z-50',
			)}
			style={{
				background: `rgba(0,0,0, ${transparency})`,
			}}
		>
			<Link to="/">
				<LOGO />
			</Link>
			<div className="flex items-center gap-3">
				<LangModule />
				<MenuModule />
			</div>
		</div>
	)
}
